import * as moment from 'moment-timezone'

const DEFAULT_TIME_FORMAT = 'hh:mm A'
const DEFAULT_DATE_FORMAT = 'll'

export const HOURS_OPTIONS = (dateFormat) => {
  const format = dateFormat ? dateFormat.time : DEFAULT_TIME_FORMAT

  return Array.from(Array(24).keys()).map((index) => ({
    value: index,
    label: hourLabelFor(index, format)
  }))
}

export const MINUTES_OPTIONS = () => {
  return Array.from(Array(60).keys()).map((index) => {
    return { value: index, label: index.toLocaleString("en-US", { minimumIntegerDigits: 2 }) }
  })
}

export const DAY_OPTIONS = (length, timezone, dateFormat) => {
  const format = dateFormat ? dateFormat.date : DEFAULT_DATE_FORMAT
  return Array.from(Array(length).keys()).map((index) => {
    const date = moment.tz(new Date(), timezone).startOf('day').add(index, 'days')
    return {
      value: date.toISOString(),
      label: date.format(format),
    }
  })
}

const hourLabelFor = (hour, format) => {
  switch (format) {
    case 'h:mm':
    case 'hh:mm':
    case 'HH:mm':
      return hour
    case 'h:mma':
    case 'hh:mm A':
    default:
      let label = hour + ' AM'
      if (hour === 12) label = '12 PM'
      if (hour > 12) label = (hour - 12).toString() + ' PM'
      return label
  }
}
